export default {
  /*按钮*/
  bt:{
    search: "Search",
    query:"Query",
    operation:"operation",
    add:"Add",
    edit: "Modify",
    delete: "Delete",
    down: "Download",
    export:"Export",
    upload: "Upload",
    enable:"enable",
    disable:"disable",
    close:"close",
    view:"view",
    confirm:"confirm",
    batchUpdateSwitchCode:"Batch Update Switch Code",
    batchUpdateStatus:"Batch Update Status",
  },
  /*Public field or tool function field*/
  common: {
    startTime: "Start Time",
    endTime: "End Time",
    creator: "Creator",
    createdBy: "Created By",
    updater: "Updater",
    updatedBy: "Updated By",
    createTime: "Create Time",
    createdAt: "Created At",
    updateTime: "Update Time",
    updatedAt: "Updated At",
    phone: "Phone Number",
    name: "Name",
    email: "Email",
    idNumber: "ID Number",
    status: "Status",
    remark: "Remark",
    fromTime: {
      label: "From",
      placeholder: "Creation Time"
    },
    toTime: {
      label: "To",
      placeholder: "Creation Time"
    }
  },
  /*User tracking page*/
  kscore:{
    month: "Number of active periods",
    profit: "Profit",
    detail:"Details",
    symbol:'tradeConfig name',
    direction:'Buying and selling direction',
    openPrice:'Opening price',
    closePrice:'Close price',
    createTime:'Close time',
  },
  registerLog:{
    dataType: "Data Type",
    driverType: "Device Type",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    utmContent:"Ad Group",
    utmTerm: "Keyword",
    ipAddress: "IP Location",
    href:"Source URL",
    referrer: "Landing Page",
    directPhone: "referrer's mobile phone number",
    phonePre: "Phone Area Code",
    title:"Gender",
    businessType: "Business Group",
    ruleId: "SMS rule id",
    register:"Original Customer List",
  },
  accountReward:{
    activeId: "Activity ID",
    activeStatus: "Active Status",
    activeName: "Activity Name",
    activeType: "Activity Type",
    proposalNo: "Proposal Number",
    beginDate: "Activity start time",
    endDate: "Activity end time",
    expDay: "Validity Period",
    proposalUser: "Proposer",
    proposalDate: "Proposal Time",
    approvalUser: "Approval Person",
    approvalDate: "Approval time",
    proposalType: "Proposal Type",
    proposalStatus: "Proposal Status",
    applyProposal: "Execute Proposal",
    cancelProposal: "Cancel Proposal",
    applySuccess: "Successful execution",
    applyFail: "Execution failed",
    choiceOne: "Please choose a proposal",
    notSatisfiable: "The proposal does not meet the requirements",
    downloadProActivity: "Recommended bonus activity proposal",
    excuteCustomerNumber:'Member Account',
    demo:'Account Type',
    levelType:'Account level',
    mobilePhone:'Phone',
    chineseName:'Name',
    directPhone:'Direct referrer',
    directindirect:'Direct/indirect referrer',
    indirectPhone:'Indirect Referrer',
    symbolType:'Product Type',
    execVolume:'Number of transactions',
    complianceExecVolume:'Customer trading lots/compliant lots',
    complianceStatus:'Compliance status',
    ctime:'Time to reach standard',
    userCreateDate:'Account opening time',
    activeTime:'Activation time',
    downloadEffectiveCustomer:'Effective Customer Record',
    downloadActivity:'Trading rebate activity',
    downloadActivity0:'Recommended bonus activity',
  },
  rewardTradeDetails:{
    currentCustomerNumber:'Settlement account number',
    currentMobilePhone:'Settlement account phone number',
    currentChineseName:'settlement account name',
    excuteCustomerNumber:'Customer trading account number',
    mobilePhone:'Customer Mobile Number',
    demo:'Account Type',
    levelType:'Account level',
    symbolType:'Product Type',
    symbol:'Product',
    orderid:'position number',
    execVolume:'Number of transactions',
    relationType:'reward type',
    directPhone:'Direct referrer',
    indirectPhone:'Indirect Referrer',
    currentRebete:'Amount',
    ctime:'Settlement time',
    downloadTradeDetails:'Reward Details Record',
  },
  rewardDealList:{
    createDate:'Settlement time',
    currentCustomerNumber:'Settlement account number',
    currentMobilePhone:'Settlement mobile phone number',
    currentChineseName:'settlement customer name',
    customerStatus:'Account Status',
    currentRebete:'Reward amount',
    correctionRebete:'Adjustment amount',
    finalRebete:'Final rebate',
    proposalStatus:'Status',
    updateUser:'modified person',
    updateDate:'modification time',
    approvalUser:'Approval person',
    approvedDate:'Approval time',
    remark:'Remarks (Rejection Reason)',
    confirmSubmit:'Confirm Submit',
    confirmSuccess: "Submit successfully",
    confirmFail: "Submit failed",
    cancel:'Cancel',
    confirm:'OK',
    cancelProposal:'Cancel Proposal',
    refuse:'Reject the proposal',
    apply:'Approval',
    reason:'reason',
    limit:'Limit adjustment table',
    refuseProposal:'Refuse',
    downloadLimit:'download limit adjustment table'
  },
  relationList:{
    customerRelation:'User recommendation relationship',
    customerRelationPro:'User recommendation relationship proposal',
    customerNum:'transaction account number',
    mobilePhone:'Mobile phone number',
    userName:'Name',
    userLevel:'Account Level',
    createDate:'Account opening date',
    activeTime:'Activation time',
    newdirectPhone:'Direct recommender',
    remark:'Remarks',
    customerNumber:'member account',
    phone:'Phone',
    direct:'Direct/Indirect Referrer',
    matchType:'Recommendation relationship',
    activeStatus:'Activation Status',
    demoCustomerNum:'Analog Account',
    directNumber:'Direct recommender account',
    directPhone:'Directly recommend the person phone',
    indirectNumber:'indirect referrer account',
    indirectPhone:'Indirect referral phone',
    inviteCode:'Invite code',
    useInviteCode:'Invite code exists',
    directInviteCode:'Direct invite code',
    reStatus:'matching result',
    proposalUser:'Proposer',
    proposalDate:'Proposal time',
    approvalUser:'Approval person',
    approvalDate:'Approval time',
    applyProposal: "Execute Proposal",
    cancelProposal:'Cancel Proposal',
    beginDate:'Account opening start time',
    endDate:'Account opening end time',
    proposalStatus:'Proposal Status',
    proposalNo:'Proposal number',
  },
  faceConfig:{
    deleteSuccess:'Delete successfully!',
    updateSuccess:'Modified successfully!',
    code:'channel code',
    name:'channel name',
    type:'Verification Type',
    thirdParty:'Third Party Interface',
    cost:'cost',
    status:'Status',
    statusUpdateBy: 'Status Updated by',
    statusUpdateDate: 'Status Updated at',
    remark:'Remarks',
    verifyCode:'Manufacturer Channel',
    verifyType:'Verification Type',
    verifyTypeCN:'Verify Type Chinese',
    describe:'Verify description',
    device:'Platform Type',
    channel:'Channel name',
    channelDesc: 'Channel name，E.g. Android: cf / iOS: com.cfd.cf',
    version:'Version number',
    versionDesc: 'Version number，E.g. Android: 111 / iOS: 1.1.1',
    switchCode:'Channel switch',
    faceStatus:'Face Control',
    createDate:'Created time',
    createUser:'Creator',
    updateUser:'Modify person',
    updateDate:'Modification time',
    submitSuccess:'Operation successful',
    faceRecord:'Verification Record',
    chineseName:'Name',
    card:'ID',
    phone:'Mobile phone number',
    recordDate:'Record time',
    channelName:'channel name',
    result:'Comparison result',
    resultParam:'Query output',
    count:'Number of uses',
    successCount:'Number of successes',
    artificialCount:'Number of successful manual calls',
    systemCount:'Number of successful system calls',
    needSelectRecord: 'Please select at least one record',
    channelExportButton: 'Export log',
  },
  creditLevel:{
    updateList:'Credit rating modification list',
    journal:'modification log',
    batchImport:'Batch import',
    uploadTip:'Drag the file here, or',
    uploadTip1:'click to upload',
    uploadTip2:'Only upload xlsx files, and no more than 10M',
    uploadSuc:'File upload successfully',
    uploadFail:'File upload failed',
    downTemplate:'Download template',
    uploadFile:'Upload now',
    batchUpdate:'Batch modification',
    customerNo:'Member account',
    pkey:'P tag',
    creditLevelOld:'Credit level before modification',
    creditLevelOriginal:'Current user credit level',
    creditLevel:'Credit Level',
    remark:'Remarks',
    createDate:'Created time',
    createUser:'Creator',
    updateUser:'Modify person',
    updateDate:'Modification time',
  },
  starLevel:{
    updateList:'Star level modification list',
    journal:'modification log',
    batchImport:'Batch import',
    uploadTip:'Drag the file here, or',
    uploadTip1:'click to upload',
    uploadTip2:'Only upload xlsx files, and no more than 10M',
    uploadSuc:'File upload successfully',
    uploadFail:'File upload failed',
    downTemplate:'Download template',
    uploadFile:'Upload now',
    batchUpdate:'Batch modification',
    customerNo:'Member account',
    starLevelOld:'Star level before modification',
    starLevelOriginal:'Current user star level',
    starLevel:'Star Level',
    remark:'Remarks',
    createDate:'Created time',
    createUser:'Creator',
    updateUser:'Modify person',
    updateDate:'Modification time',
    update:'Modify ',
    dataType:'Modify Type',
  },
  rebateComponents:{
    subtotal:'Subtotal',
    total:'Total',
    tradeLogList:'Rebate details record details',
    cancel:'Cancel',
    confirm:'Confirm',
    symbolType:'Product Type',
    displayName:'Product',
    orderId:'position number',
    execVolume:'Trading lots',
    rebateAmount:'rebate amount',
    activeName:'active name',
    activity:'activity time',
    activeId:'Activity ID',
    effective:'Effective customer condition setting',
    tips:'New customer account opening and activation time must be within the activity period',
    beginDate: "Start Time",
    endDate: "End Time",
    expDate: "Start Date of Validity Period",
    expDay: "Validity Period",
    productType: "Product Type",
    me: "Customer",
    direct: "Direct Recommendation",
    indirect: "Indirect recommendation",
    quantity: "Requirements for the number of transactions",
    highAmount:'Highest reward amount',
    highAmount2:'New customers highest contribution rebate',
    highPoint:'Customers recommended accumulatively get the highest rebate',
    add:'Add',
    update:'Modify',
    dollar:'dollar',
    day:'day',
    activeTime:'Activation Date',
    reward:'Recommended bonus setting',
    rebate:'Trading rebate settings',
    addCondition:'Add Condition',
    min:'mini',
    std:'standard',
    vip:'Golden Diamond',
    to:'to',
    all:'All',

  },
  risk:{
    name:"Gateway Name",
    baseSetting: "Basic User Configuration",
    specialSetting: "Specific User Configuration",
    ipSetting: "ip rule configuration",
    addBaseSetting: "Add Rule User Group",
    addspecialSetting: "Add a specific user group",
    settingTpye: "Configuration Type",
    userType: "User Group",
    pkey: "P tag",
    nkey: "N tag",
    creditLevel: "Credit Level",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    limitSetting: "Limit Rules",
  },
  registervalidate:{
    customerNo: "Account",
    registerType: "Account Opening Type",
    target:"tag",
    creditTunnel2: "Credit Channel 2",
    creditTunnel3: "Credit Channel 3",
    validateStatus2: "Two-element validation status",
    validateStatus3: "Three-element validation status",
    registerStatus: "Account Opening Status",
    channel: "channel source",
    kycResult: "kyc verification result",
    personMarkTunnel: "Credit Investigation Litigation Channel",
    personMarkResult: "Credit Investigation Litigation Verification Result",
    creditLoanTunnel: "Credit Overdue Channel",
    creditLoanResult: "Credit overdue verification result",
  },
  tracker:{
    customerNo: "User Account",
    openStartTime: "Account opening start time",
    openEndTime: "Account opening end time",
    activeStartTime: "Activation start time",
    activeEndTime: "Activation End Time",
    userType: "Account Type",
    isActive: "Activation Status",
    isShow: "Column segment display/hide",
    businessType: "Business Group",
    relatedAccount: "Associated Account",
    levelType: "Account Level",
    userAge: "Age",
    gender:"Gender",
    birthday:"Date of Birth",
    ctime: "Account Opening Date",
    pkey: "P tag",
    nkey: "N tag",
    creditLevel: "Credit Level",
    href:"source url",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    utmContent:"Ad Group",
    utmTerm: "Keyword",
    activeTime: "Activation Time",
    ipAddress: "IP Location",
    userAgent: "Browser",
    checkStatus: "IVI Verification Status",
    arbitrageurTags: "IVI Verification Tag",
    directAccount:"referrer's account",
    directPhone: "referrer's mobile phone number",
    tracker: "User Tracking",
    inviteCode:'Invite code',
    isInviteCode:'Invite code exists',
    directInviteCode:'Direct invite code'
  },
  activeTemplate:{
    type:"Activity Type",
    url: "Release domain name",
    detail: "Module Template",
    field:"Ad Attributes",
    fieldTitle: "Attribute Name",
    fieldField: "Attribute Code",
    fieldType: "Attribute Type",
    text:"Text",
    img:"Picture",
    title:"Template Title",
    activeTime: "active time",
    author:"Publisher",
  },
  advertising:{
    key: "key",
    value: "value",
    type: "type",
    createTime:"createTime",
    name:"Name of advertising",
    platform:"Application platform",
    term:"The period of validity",
    accountType:"Account type",
    isActive:"active",
    userLevel:"Account level",
    aboutType:"Degree of conversion",
    position:"Advertising position",
    positionType:"AD types",
    channel:"channel",
    adverInfo:"Advertising for details",
    startTime:"The start time",
    endTime:"Effect of time",
    status:"state",
    carapace:"Vest bag",
    time:"To take effect",
    param:"Apply to the user",
    url:"To upload pictures",
    title:"The title",
    address:"address",
    content:"content",
    sort:"sort",
    simulation:"simulation",
    real:"real",
    demoCaseReal:"demoCaseReal"
  },
  analy:{
    dayActive:"Number of account activate in real-time of the day",
    dayReal:"Real account opened on the day",
    dayDemo:"Demo account opened on the day",
    dayRealDemo:"Real account+demo account opened on the day",
    in:"that",
    dayRealActive:"The number of accounts opened and activated on the day",
    weekActiveCount:"The number of activated on last 7 days",
    weekRealCount:"The Number of real accounts opened in last 7 days",
    weekDemoCount:"The Number of demo accounts opened in last 7 days",
    weekRealDemoCount:"The Number of real+demo accounts opened in last 7 days",
    realCount:"Real accounts",
    demoCount:"Demo accounts",
    realDemoCount:"Real+Demo accounts",
    averCount:"Working Day Average line",
    week0: "Sunday",
    week1: "Monday",
    week2: "Tuesday",
    week3: "Wednesday",
    week4: "Thursday",
    week5: "Friday",
    week6: "Saturday",
    dayActiveRate:"The ratio of channels for activated real-time on the day",
    dayRealRate:"The ratio of channels for real account real-time on the day",
    dayDemoRate:"The ratio of channels for demo account real-time on the day",
    dayRealDemoRate:"The ratio of channels for real+demo account real-time on the day",
    dayRealCount:"Real account opened real time on the day",
    dayDemoCount:"Demo account opened real time on the day",
    dayRealDemoCount:"Real+Demo account opened real time on the day",
    today:"Today",
    yesterday:"Yesterday",
    activeCount:"Activation Number",
  },
  smsType:{
    device:"Page side",
    type:"Verification code method",
    updateTime:"Change the time",
    modify:"Switching method"
  },
  emailTemplate:{
    emailTemplate:"Email template",
  	templateName:"Template name",
    title:"Email title",
    enabled:"Status",
    updateDate: 'Update date',
  },
  emailSend:{
    sendEmail:"Send email",
    title:"Email title",
    sendCount:"Send count",
    sucCount:"Success count",
    failCount:"Fail count",
    updateDate: 'Update date',
    sendType:"Send type",
    chooseTemplate:"Choose template",
    content:"Email content",
    receiver:"Receiver",
    uploadReceiver:"Upload receiver",
    emailList:"Email list",
    uploadTip:'Drag the file here, or',
    uploadTip1:'click to upload',
    uploadTip2:'1、Multiple mailboxes separated by English commas',
    uploadTip3:'2、Each upload will overwrite the previous mailbox',
    uploadTip4:'3、Each sending cannot exceed 5,000 mailboxes, and it can be sent multiple times if it exceeds',
    uploadTip5:'4、The email list only supports .txt or .csv file format',
    uploadTip6:'1、Attachment only supports .pdf file format',
    uploadTip7:'2、Each attachment cannot exceed 10MB in size',
    uploadSuc:'File upload successfully',
    uploadFail:'File upload failed',
    uploadFile:'Upload now',
    attachment:'Attachment',
    selectAttachment:'Select attachment',
    deleteAll:'Delete all',
    chooseChannel:"Choose channel",
    sender:"Sender",
  },
  emailChannel:{
    emailChannel:"Email channel",
    channelName:"Channel name",
    emailAddress:"Email address",
    enabled:"Status",
    updateDate: 'Update date',
  },
  agent:{
    name: "Name",
    identityCardNumber: "Identity Card Number",
    phoneNumber: "Phone",
    emailAddress: "Email",
    qqAccount: "QQ",
    wechatAccount: "WeChat",
    companyName: "Company Name",
    companyLink: "Company Link",
    createdTime: "Joined Time",
    confirmDownload: "Are you sure you want to download a file?",
    confirmMessageTitle: "Notification",
    confirmButton: "Confirm",
    cancleButton: "Cancel",
    cancleMessage: "Cancelled",
    isValid: "Is Valid",
    isValidPlaceholder: "Please select",
    isValidDefault: "Not Yet Validate",
    isValidTrue: "Valid Agent",
    isValidFalse: "InValid Agent",
    confirmValidate: "Are you sure update the status of agent?",
  },
  appProduct:{
    queryForm: {
      label: {
        chineseName: "Product Chinese Name",
        englishName: "Product English Name",
        platform: "",
        accountType: "Account Type",
        channel: "Channel",
      },
      placeholder: {
        chineseName: "Product Chinese Name",
        englishName: "Product English Name",
        platform: "Platform",
        accountType: "Account Type",
        channel: "Channel",
      },
    },
    addForm: {
      title: "Add Product",
      label: {
        platform: "Platform",
        englishName: "Product English Name",
        accountType: "Account Type",
        channel: "Channel",
        sortOrder: "Order",
      },
      placeholder: {
        englishName: "Product English Name",
      },
    },
    updateForm: {
      title: "Edit Product",
      label: {
        platform: "Platform",
        englishName: "Product English Name",
        accountType: "Account Type",
        channel: "Channel",
        sortOrder: "Order",
      },
      placeholder: {
        englishName: "Product English Name",
      },
    },
    table: {
      code: "Product Code",
      iCodeId: "iCodeId",
      chineseName: "Product Chinese Name",
      englishName: "Product English Name",
      platform: "Platform",
      channel: "Channel",
      accountType: "Account Type",
      sortOrder: "Order",
      createdDate: "Created Date",
      updatedDate: "Modified Date",
    },
    button: {
      queryAppProduct: "Query",
      addAppProduct: "Add Product",
      updateAppProduct: "Edit Product",
      deleteAppProduct: "Delete Product",
      setAmountField: "Set",
    },
    other: {
      setAmountFieldLabel:"Default Product Amount",
      setAmountFieldPlaceholder:"No value is set",
      exceedProductAmount: "Product Amount Exceeds 15 per channel",
    }
  },
  optional:{
    iCodeId: "code",
    symbol: "symbol",
    platform: "platform",
    businessType: "businessType",
    accountNo: "accountNo",
    account: "account",
    createTime: "create Time",
    channel: "channel",
  },
  nps:{
    npsId: "ID",
    realAccount: "Real Account",
    simAccount: "Sim Account",
    mobile: "Mobile Number",
    score: "Score",
    npsType: "Comment Type",
    comment: "Comment",
    createdTime: "Created Time",
    deviceOs: "Device OS",
    appVersion: "App Version",
    socreRange: "NPS Range",
    accountType: "Account Type",
    accountTypeOption1: "All",
    accountTypeOption2: "Real Account",
    accountTypeOption3: "Demo Account",
    accountTypeOption4: "All(Excluding test accounts)",
    accountTypeOption5: "Real Account(Excluding test accounts)",
    accountTypeOption6: "Demo Account(Excluding test accounts)）",
    isTestingAccount: "Is Testing Account",
    isTestingAccountTrue: "True",
    isTestingAccountFalse: "False",
    checkCommentButton: "Check Comment",
    confirmDownload: "Are you sure you want to download a file?",
    confirmMessageTitle: "Notification",
    confirmButton: "Confirm",
    cancleButton: "Cancel",
    cancleMessage: "Cancelled",
    refreshChartButton: "Refresh",
    barChartLabel: "NPS Value",
    barChartXAxisName: "Score",
    barChartYAxisName: "Comment Amount",
    pieChartPositiveTitle: "Complimentary Feedback Category",
    pieChartPositiveSubTitle: "Positive Feedback",
    pieChartNegativeTitle: "Judgemental Feedback Category",
    pieChartNegativeSubTitle: "Negative Feedback",
    pirChartLegend1: "Product Leverage",
    pirChartLegend2: "Product Richness",
    pirChartLegend3: "Real Time Information",
    pirChartLegend4: "Analyst",
    pirChartLegend5: "Instant Account Opening",
    pirChartLegend6: "Instant Deposits & Withdrawals",
    pirChartLegend7: "Customer Service",
    pirChartLegend8: "Trading Experience",
    pirChartLegend9: "Promotions",
    pirChartLegend10: "Others",
  },
  lp:{
    name: "Name",
    phoneNumber: "Phone",
    sourceUrl: "Source",
    createdTime: "Joined Date",
    confirmDownload: "Are you sure you want to download a file?",
    confirmMessageTitle: "Notification",
    confirmButton: "Confirm",
    cancleButton: "Cancel",
    cancleMessage: "Cancelled",
  },
  feedback:{
    queryForm: {
      label: {
        accountType: "Account Type",
        realAccount: "Real Account",
        demoAccount: "Demo Account",
        createdTime: "Created Time",
        createdTimeTo: "To",
        channel: "Channel",
        contact: "Contact",
        hasImage: "Image",
        validateStatus: "Validate Status",
        accountStatus: "Account Status",
        platform: "Platform",
      },
      placeholder: {
        realAccount: "Real account",
        demoAccount: "Demo account",
        createdStartTime: "Start from",
        createdEndTime: "End to",
        contact: "Any",
        hasImage: "Any",
        validateStatus: "Any",
        platform: "Any",
      },
      option: {
        accountType: {
          all: "All",
          realAccount: "Real account",
          demoAccount: "Demo account",
          visitor: "Visitor",
        },
        contact: {
          any: "Any",
          phone: "Phone",
          wechat: "Wechat",
        },
        image: {
          any: "Any",
          has: "Has",
          no: "No",
        },
        validateStatus: {
          any: "Any",
          valid: "Valid",
          invalid: "Invalid",
        },
        channel: {
          placehoder: "All"
        },
        accountStatus: {
          any: "Any",
          test: "Test Account",
          real: "Non-test Account",
        },
        platform: {
          any: "Any",
          app: "App",
          mobile: "Mobile",
          pc: "PC"
        }
      },
      button: {
        query: "Query",
        download: "Encrypted Download",
        export: "Export",
      },
      messageBox: {
        title: "Notification",
        message: "Are you sure you want to download a file?",
        confirm: "Confirm",
        cancel: "Cancel",
        cancelMessage: "Cancelled",
      }
    },
    table: {
      header: {
        feedbackNo: "Feedback No.",
        realAccount: "Real Account",
        demoAccount: "Demo Account",
        phone: "Phone",
        wechat: "Wechat",
        feedbackType: "Type",
        description: "Description",
        createdTime: "Created Time",
        platform: "Platform",
        channel: "Channel",
        appVersion: "App Version",
        hasImage: "Image",
        operation: "Operation",
        isTestingAccount: "Test Account"
      },
      button: {
        view: "View",
        validate: "Validate",
        valid: "Valid",
        invalid: "Invalid",
      },
      messageBox: {
        title: "Notification",
        message: "Are you sure you want to change the status to ({status})?",
        confirm: "Confirm",
        cancel: "Cancel",
        cancelMessage: "Cancelled",
      },
      value: {
        true: "True",
        false: "False",
      }
    },
    modal: {
      title: "Feedback Content",
      label: {
        content: "Content",
        image: "Uploaded Images",
      },
      close: "Close",
      confirm: "Confirm",
    }
  },
  vpnConfig:{
    queryForm:{
      label:{
        node: "Node",
        domain: "Domain",
        ip:"IP",
        isValid:"Is Valid"
      },
      placeholder:{
        node: "Search Node",
        domain: "Search Domain",
        ip:"Search IP",
        isValid:"Any"
      },
      optionList:{
        any:"Any",
        valid:"Valid",
        invalid:"Invalid"
      },
      button:{
        query:"Query",
        reset:"Reset",
        add:"Add"
      }
    },
    table:{
      header:{
        node:"Node",
        domain:"Domain",
        ip:"IP",
        remark:"Remark",
        createdBy:"Created User",
        createdAt:"Created Time",
        updatedBy:"Modified User",
        updatedAt:"Modified Time",
        operation:"Operation"
      },
      button:{
        validate: "Validate",
        valid:"Valid",
        invalid:"Invalid",
        modify:"Modify",
        delete:"Delete"
      }
    },
    messageBox:{
      validate:{
        title: "Confirm",
        message: "Are you sure to change the status of this VPN config to {status}?",
      },
      delete:{
        title: "Confirm",
        message: "Are you sure to delete this VPN config?",
      },
      button:{
        confirm:"Yes",
        cancel:"Cancel"
      },
      cancleMessage: "Cancelled",
    },
    modal:{
      create:{
        title:"Add VPN Config",
      },
      update:{
        title:"Modify VPN Config",
      },
      label:{
        node:"VPN Node Name",
        domain:"VPN Domain",
        ip:"IP",
        config:"VPN Config",
        remark:"Remark",
      },
      placeholder:{
        node:"Name of the node",
        domain:"Support multiple domains(use ',' to seperate each domain)",
        ip:"IPv4 format;Support multiple IPs(use ',' to separate each IP)",
        config:"Corresponding VPN config string",
        remark:"Optional",
      },
      button:{
        create:"Submit",
        update:"Modify",
        cancel:"Cancel"
      },
      message:{
        successCreate: "Submit the VPN config successfully",
        successUpdate: "Modified the VPN config successfully"
      }
    }
  },
  appAbChannel: {
    common: {
      id: "ID",
      filename: "_Available Area List_",
      emptyArea: "Not set"
    },
    message:{
      invalid: "Invalid operation",
      success: "Request successful",
      fail: "Request failed",
      unknown: "Unknown error"
    },
    form: {
      appName: {
        label: "App Name",
        placeholder: "Supports fuzzy search by name"
      },
      status: {
        label: "Status",
        placeholder: "All"
      },
      area: {
        label: "Enabled Cities",
        placeholder: "Search city name"
      },
      button: {
        blacklist: "IP Blacklist"
      }
    },
    table: {
      appName: "App Name",
      appFlavor: "App Identifier",
      status: "B Package Status",
      area: "Enabled Areas (Cities)",
      createdAt: "Created At",
      createdBy: "Created By",
      updatedAt: "Updated At",
      updatedBy: "Updated By",
      operation: {
        export: "Download Areas"
      }
    },
    modal: {
      appName: {
        label: "App Name",
        placeholder: "Enter app name"
      },
      appFlavor: {
        label: "APP Identifier",
        placeholder: "Enter APP identifier"
      },
      status: {
        label: "Status",
        placeholder: "Select status"
      },
      area: {
        label: "Enabled Area Range",
        placeholder: "Select enabled area range",
        button: "Upload Area List"
      },
      remark: {
        label: "Remark",
        placeholder: "Remark (optional)"
      }
    },
    blacklist: {
      title: "IP Blacklist Management",
      message: {
        invalid: "Invalid IPv4 address format."
      },
      table: {
        id: "ID",
        ipAddress: "IP Address",
        remark: "Remark"
      },
      modal: {
        title: "Add Blacklist IP",
        ipAddress: {
          label: "IP Address",
          placeholder: "e.g. 192.168.1.1"
        },
        remark: {
          label: "Remark",
          placeholder: "Remark (optional)"
        }
      }
    }
  },
  appChannel: {
    message: {
      invalid: "Invalid operation",
      success: "Request successful",
      fail: "Request failed",
      unknown: "Unknown error",
      duplicate: "Duplicate with existing data",
    },
    form: {
      name: {
        label: "Channel Name",
      },
      flavor: {
        label: "Channel Package Name"
      },
      os: {
        label: "Operating System"
      },
      client: {
        label: "Front-end Page"
      }
    },
    table: {
      name: "Channel Name",
      flavor: "Channel Package Name",
      os: "Operating System",
      client: "Front-end Page"
    },
    modal: {
      name: {
        label: "Channel Name",
        placeholder: "Please enter channel name"
      },
      flavor: {
        label: "Channel Package Name",
        placeholder: "Please enter channel package name"
      },
      os: {
        label: "Operating System"
      },
      client: {
        label: "Front-end Page"
      }
    }
  }
};
